import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ProformaService } from '../../proforma/proforma.service'; // change import path to '../proforma.service' in kbmresorts

@Component({
    selector: 'app-proforma-target',
    templateUrl: './proforma-target.component.html',
    styleUrls: ['./proforma-target.component.css'],
    standalone: false
})
export class ProformaTargetComponent implements OnInit {
  	form1: UntypedFormGroup;
	formLoading = false;
	formErrorMessage:any;
	proforma:any;

  validationMessages =
		{
			'targetTotal': [{ type: 'required', message: 'New target is required.' }],
		};


  constructor(private formBuilder: UntypedFormBuilder,
		private messageService: MessageService,
		public proformaService : ProformaService,
		public dynamicDialogRef: DynamicDialogRef,
		public dynamicDialogConfig: DynamicDialogConfig,
		@Inject(MAT_DIALOG_DATA) data: any) { 
			this.proforma = data.proforma

		}

	@Output() doUpdate = new EventEmitter<any>();

  ngOnInit(): void {
	if (this.dynamicDialogConfig.data) {
		this.proforma = this.dynamicDialogConfig.data.proforma
	}
	//this.proforma = this.dynamicDialogConfig?.data?.proforma
		this.buildForm();

  }
  onFormSubmit() {
		if (this.form1.invalid) {
			return;
		}
		this.proforma.targetTotal = this.form1.value.targetTotal;
		try {
			this.formLoading = true;
			this.proformaService.setTarget(this.proforma)
				.subscribe(
					(res:any)=> {
						this.messageService.add({
							severity: "success",
							summary: "Success",
							detail: 'Target Set to ' + parseFloat(res.data.proforma.targetTotal).toFixed(2),
						});
						this.doUpdate.emit(res);
						this.dynamicDialogRef.close(res.data.proforma);
						this.formLoading = false;
						setTimeout(() => {
							this.messageService.clear();
						}, 2000);
						// this.dynamicDialogRef.close(this.form1.value);
					},
					(err:any) => {
						this.messageService.add({
							severity: "error",
							summary: "Error",
							detail: err,
						});
						this.formLoading = false;
						setTimeout(() => {
							this.messageService.clear();
						}, 2000);
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
					},
					() => { });
		} catch (error) {
			this.formLoading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
		}
	}

	buildForm() {
		this.form1 = this.formBuilder.group({
			//rateBucketId: [this.rateBucket.rateBucketId],
			proformaId: [this.proforma.proformaId],
			targetTotal: [, Validators.required],
		});
	}

}
